module.exports = __webpack_public_path__ + "static/media/grid.df5aca4d.jpg";